import React from 'react';

const BRAND_BROWN = '#8B4513';

export default function Button({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  onClick,
  style,
  type = 'button'
}) {
  const baseStyle = {
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s',
    fontFamily: 'inherit',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  };

  const sizePad = size === 'small' ? '8px 16px' : size === 'large' ? '14px 28px' : '10px 20px';
  const sizeFont = size === 'small' ? '13px' : size === 'large' ? '16px' : '14px';

  const variants = {
    primary: {
      background: disabled ? 'var(--btn-disabled-bg)' : BRAND_BROWN,
      color: disabled ? '#555' : 'white',
      // Light edge + shadow so it stands out on the dark photo top bar too
      border: '1px solid rgba(255,255,255,0.55)',
      boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
      padding: sizePad,
      fontSize: sizeFont
    },
    secondary: {
      // Solid white (never see-through) so it's readable on any background
      background: disabled ? 'var(--btn-disabled-bg-soft)' : 'white',
      color: disabled ? 'var(--btn-disabled-text)' : BRAND_BROWN,
      border: `1px solid ${disabled ? 'var(--btn-disabled-border)' : BRAND_BROWN}`,
      boxShadow: disabled ? 'none' : '0 1px 4px rgba(0,0,0,0.18)',
      padding: sizePad,
      fontSize: sizeFont
    },
    danger: {
      background: disabled ? 'var(--btn-disabled-bg-soft)' : 'var(--error)',
      color: 'white',
      padding: sizePad,
      fontSize: sizeFont
    }
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{
        ...baseStyle,
        ...variants[variant],
        ...style
      }}
    >
      {children}
    </button>
  );
}
